import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from '@/composables/i18n';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import QuickSearchItem from '@/models/metrics/quickSearchItem';
import { isNil } from '@/utils/misc';
import { computed, onMounted, ref, watch } from 'vue';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'QuickSearchButton',
  props: {
    dataFetch: null,
    value: { default: FilterTimeAxisSpanEnum.Day },
    position: { default: 'is-right' }
  },
  emits: ["select"],
  setup(__props: any, { emit }: { emit: ((e: 'select', value: QuickSearchItem) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { dataFetch: () => Promise<QuickSearchItem[]>, value: FilterTimeAxisSpanEnum, position: string };





const { t } = useI18n();
const data = ref<QuickSearchItem[]>([]);
const selectedName = ref('');
const infoLoaded = ref(false);

onMounted(async () => {
  await initialize();
});

async function initialize() {
  infoLoaded.value = false;
  data.value = await props.dataFetch();
  selectedName.value = '';
  infoLoaded.value = true;
}

function onSelect(item: QuickSearchItem | null) {
  if (!isNil(item)) {
    emit('select', item);
  }
}

const placeholderText = computed(() => {
  const index = Math.floor(Math.random() * data.value.length);
  return t('report.example_abbrev', [data.value[index].name]);
});

const filteredData = computed(() =>
  data.value.filter(
    (entry) =>
      entry.name.toLowerCase().indexOf(selectedName.value.toLowerCase()) >= 0,
  ),
);

watch(props.dataFetch, async () => {
  await initialize();
});

return { __sfc: true,props, emit, t, data, selectedName, infoLoaded, initialize, onSelect, placeholderText, filteredData }
}

})